// ======================================================================
// File Name       : LiveReservedDetailUserList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Button } from 'react-bootstrap';
import TableHead from '../../components/TableHead';

const thead = [
  { title: 'ユーザー名', sortBy: null },
  { title: 'ログインID', sortBy: null },
  { title: 'グループ名', sortBy: null },
];

class LiveReservedDetailUserList extends React.Component {
  render() {
    const {
      edittingUserList,
      userLiveRelationList,
      showModal,
      removeUserFromList,
      isConfirm,
    } = this.props;
    let tbody = null;
    if (
      edittingUserList &&
      userLiveRelationList &&
      userLiveRelationList.bySecernIds &&
      Object.keys(edittingUserList).length
    ) {
      tbody = Object.keys(edittingUserList).map((userSecernId, index) => {
        const user = userLiveRelationList.bySecernIds[userSecernId];
        if (!user) return null;
        return (
          <tr key={index}>
            <td className="text-left">{user.userName}</td>
            <td className="text-left">{user.loginId}</td>
            <td className="text-left">{user.groupNames}</td>
          </tr>
        );
      });
    }
    return (
      <div className="col-sm-12 padding-left-right-clear padding-top-10">
        <p>ライブに招待するユーザーの一覧</p>
        <Table striped hover className="margin-top-10">
          <thead>
            <TableHead data={thead} />
          </thead>
          <tbody>{tbody}</tbody>
        </Table>
      </div>
    );
  }
}

export default LiveReservedDetailUserList;
